import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { IoIosArrowForward, IoMdCheckmark } from "react-icons/io";
import { LazyLoadImage } from "react-lazy-load-image-component";

export const Project = ({ json, imageMap }) => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, [location]);

  return (
    <>
      <div className="sm:text-[30px] text-[25px] font-[500] mt-3">Project Goal</div>
      <div className="sm:text-[20px] text-[18px] text-secondary sm:text-left">
        {json?.goal}
      </div>
      <div className="sm:text-[30px] text-[25px] font-[500] mt-3">Project Details</div>
      <div className="text-[18px] flex flex-col justify-start gap-y-3">
        <div>{json?.details?.detail}</div>
        <div>{json?.details?.text}</div>
        <u1 className="sm:text-[18px] text-[16px] list-none">
          {(json?.details?.points || []).map((point) => {
            return (
              <li className="flex justify-start items-start gap-x-1 w-full">
                <IoIosArrowForward className="mt-1 sm:mt-1.5 w-[5%]" />
                <div className="w-[95%]">{point}</div>
              </li>
            );
          })}
        </u1>
      </div>
      <div className="sm:text-[30px] text-[25px] font-[500] mt-3">Key Features</div>
      <div className="text-[18px] flex flex-col sm:items-start sm:justify-start items-center justify-center sm:pr-20 gap-6">
        {json?.features?.map((feature) => {
          if (feature?.img) {
            return (
              <LazyLoadImage
                src={imageMap?.[feature?.img]}
                alt={feature?.img}
                className="w-full rounded-lg"
              />
            );
          }
          if (feature?.text) {
            return (
              <div className="flex justify-start items-start w-full gap-x-1">
                <IoMdCheckmark size={20} className="mt-1 w-[5%]" />
                <div className="w-[95%]">
                  <span className="mr-1 font-bold">{feature?.bold}: </span>
                  {feature?.text}
                </div>
              </div>
            );
          }
          if (feature?.img1) {
            return (
              <div className="flex sm:flex-row flex-col justify-center items-center gap-2">
                <LazyLoadImage
                  src={imageMap?.[feature?.img1]}
                  alt={feature?.img1}
                  className="sm:w-1/2 w-full rounded-lg"
                />
                <LazyLoadImage
                  src={imageMap?.[feature?.img2]}
                  alt={feature?.img2}
                  className="sm:w-1/2 w-full rounded-lg"
                />
              </div>
            );
          }
          return null;
        })}
      </div>
      <div className="sm:text-[30px] text-[25px] font-[500] mt-3">Achievements</div>
      <u1 className="sm:text-[18px] text-[16px] list-none">
        {json?.achievements?.map((achievement) => {
          return (
            <li className="flex justify-start items-start gap-x-1 w-full">
              🏆
              <div className="w-[95%]">{achievement}</div>
            </li>
          );
        })}
      </u1>
    </>
  );
};
